// extracted by mini-css-extract-plugin
module.exports = {"section":"C2_section__gVYrX","pulse-scale":"C2_pulse-scale__Q5RbM"};